import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "src/components/Actions/ActionsMenu";
import { useCallback, useMemo } from "react";
import { useAccess } from 'src/hooks/useAccess.hook';
import { FEATURE } from 'src/util/enums';

export const ChargingSiteActionMenu = (props) => {
  const {
    setCreateZoneBtn,
    rowData,
    handleAction,
    hasEditAccess: propsHasEditAccess,
    hasDeleteAccess: propsHasDeleteAccess,
    hasViewAccess: propsHasViewAccess,
  } = props;
  const internalHasEditAccess = useAccess(FEATURE.CHARGINGSITE, "U");
  const internalHasDeleteAccess = useAccess(FEATURE.CHARGINGSITE, "D");
  const internalHasViewAccess = useAccess(FEATURE.CHARGINGSITE, "V");

  const hasEditAccess = propsHasEditAccess ?? internalHasEditAccess;
  const hasDeleteAccess = propsHasDeleteAccess ?? internalHasDeleteAccess;
  const hasViewAccess = propsHasViewAccess ?? internalHasViewAccess;

  const onEdit = useCallback(() => {
    setCreateZoneBtn(true);
    handleAction({ action: "", id: rowData.zone_id });
  }, [setCreateZoneBtn, handleAction, rowData.zone_id]);

  const onDeleteZone = useCallback(() => {
    handleAction({ action: "forDelete", id: rowData.zone_id });
  }, [handleAction, rowData.zone_id]);

  const onView = useCallback(() => {
    handleAction({ action: "view", id: rowData.zone_id });
  }, [handleAction, rowData.zone_id]);

  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        action: onView,
        hidden: !hasViewAccess,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        action: onEdit,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDeleteZone,
        hidden: !hasDeleteAccess,
      },
    ],
    [onView, onEdit, onDeleteZone, hasViewAccess, hasEditAccess, hasDeleteAccess]
  );
  
  return <ActionsMenu menuList={actionList} />;
};
